import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import CLocalizedTextStringStatic from '../../components/CLocalizedTextStringStatic';
import { PageRoutes } from '../../enums/enums';
import { useAppDispatch } from '../../hooks/hooks';
import { addBreadcrumbTextReplacement, purgeBreadcrumbTextReplacementDictForOutlets } from '../../store/appSlice';

export default function PLocalisationOutlet() {
  const dispatch = useAppDispatch();
  const i18nHeadingTitle = CLocalizedTextStringStatic('i18n.heading.title');
  useEffect(() => {
    dispatch(addBreadcrumbTextReplacement([PageRoutes.I18N_CENTER_OUTLET, i18nHeadingTitle]));

    return () => {
      dispatch(purgeBreadcrumbTextReplacementDictForOutlets());
    };
  }, [dispatch, i18nHeadingTitle]);
  return <Outlet />;
}
